'use client';
const MANIFEST_IMAGES = {
    legalWarning: {
        hashed: 'legal-warning.14e030436e9ab3e5a708ec3fb9d655a1.png',
        versioned: 'legal-warning.png'
    }
};

export { MANIFEST_IMAGES };
